export default __webpack_public_path__ + "static/media/IMG-20220413-WA0023@2x.a2dd685f.webp";